import React from "react";
import styles from "./content.module.css";

const ContentContainer = ({ children, className = "" }) => {
  return <div className={`${styles.container} ${className}`}>{children}</div>;
};

export default ContentContainer;
